import React from 'react';
import PropTypes from 'prop-types';
import InlineSection from '../../../../InlineSection';

const DetailInlineSection = ({ detail, detailClass, icon, title, theme }) => (
    <InlineSection
        theme={ theme }
        icon={ icon }
        mainContent={ title }
        subContent={ (
            <span className={ detailClass }>
                { detail }
            </span>
        ) }
    />
);

DetailInlineSection.propTypes = {
    theme: PropTypes.shape({}),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    icon: PropTypes.shape({
        name: PropTypes.string,
        className: PropTypes.string,
    }).isRequired,
    detailClass: PropTypes.string,
    detail: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
};

export default DetailInlineSection;
